module.exports = __webpack_public_path__ + "img/drugstores.90fea215.jpeg";